import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase 환경 변수가 설정되지 않았습니다.');
  throw new Error('Supabase configuration is missing');
}

// Supabase 클라이언트 생성 (싱글톤 패턴)
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
  },
  global: {
    headers: {
      'x-client-info': 'supabase-js-web',
    },
  },
  // 재시도 설정 추가
  db: {
    schema: 'public',
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

// 연결 상태 확인 함수
export const checkSupabaseConnection = async () => {
  try {
    const { error } = await supabase.from('gallery').select('count', { count: 'exact', head: true });
    if (error) {
      console.error('Supabase 연결 오류:', error.message);
      return false;
    }
    return true;
  } catch (err) {
    console.error('Supabase 연결 실패:', err);
    return false;
  }
};
